import { SocialProfilesService } from './SocialProfilesService';

export default new SocialProfilesService('instagram/profiles');
